module.exports = __webpack_public_path__ + "56ef23607dc21644e73936da1c70e1c6.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/sensitivity.png
// module id = 928
// module chunks = 7